import { render, staticRenderFns } from "./modal-error.vue?vue&type=template&id=5ffd40e6"
import script from "./modal-error.vue?vue&type=script&lang=js"
export * from "./modal-error.vue?vue&type=script&lang=js"
import style0 from "./modal-error.vue?vue&type=style&index=0&id=5ffd40e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports